<template>
  <v-dialog v-model="dialog" max-width="600px">
    <template v-slot:activator="{ on, attrs }">
      <v-list-item v-bind="attrs" v-on="on">
        <v-list-item-icon>
          <v-icon>mdi-email-fast</v-icon>
        </v-list-item-icon>
        <v-list-item-title> ENVIAR RECIBO</v-list-item-title>
      </v-list-item>
      <!-- <v-btn text v-bind="attrs" v-on="on">
        <v-icon dense color="grey darken-2">
          mdi-email-fast
        </v-icon>
        Enviar por correo</v-btn> -->
      <!-- <v-list-item-title v-bind="attrs" v-on="on"> <v-icon dense color="grey darken-2">
          mdi-email-fast
        </v-icon> Enviar recibo</v-list-item-title> -->
    </template>
    <v-card>
      <v-card-title>
        <span class="headline">Enviar invitación</span>
      </v-card-title>
      <v-card-text class="bg-surface-light pt-4">
        Se enviará una invitación a realizar el pago pendiente al titular mediante el <strong>correo ingresado</strong>
        anexando el recibo de pago.
        <v-form ref="form" v-model="valid" lazy-validation @submit.prevent="sendEmail">
          <v-text-field v-model="email" label="Correo electrónico" :rules="[rules.required, rules.email]"
            required></v-text-field>
          <!-- <v-text-field
              v-model="subject"
              label="Asunto"
              :rules="[rules.required]"
              required
            ></v-text-field>
            <v-textarea
              v-model="message"
              label="Mensaje"
              :rules="[rules.required]"
              required
            ></v-textarea> -->
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="close">Cancelar</v-btn>
        <v-btn color="blue darken-1" text @click="sendEmail">Enviar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex'
import { EventBus } from '@/functions/event-bus'

export default {
  computed: {
    ...mapGetters(['getEmail'])
  },
  mounted() {
    this.email = this.propEmail ? this.propEmail : this.getEmail
  },
  props: {
    ReciboId: {
      type: String,
      required: true,
      default: ''
    },
    Membresia: {
      type: String,
      required: false,
      default: ''
    },
    Recibo: {
      type: String,
      default: ''
    },
    Titular: {
      type: String,
      required: true,
      default: ''
    },
    Monto: {
      type: String,
      default: ''
    },
    propEmail: {
      type: String,
      required: false,
      default: ''
    }
  },
  data() {
    return {
      dialog: false,
      valid: false,
      email: '',
      subject: '',
      message: '',
      rules: {
        required: value => !!value || 'Requerido.',
        email: value => {
          const pattern = /^[^@]+@[^@]+\.[a-zA-Z]{2,}$/
          return pattern.test(value) || 'Correo electrónico inválido.'
        }
      }
    }
  },
  methods: {
    close() {
      this.dialog = false;

    },
    sendEmail() {

      if (this.$refs.form.validate()) {

        EventBus.$emit('show-snackbar', {
                text: `El correo se esta enviando, un momento por favor.`,
                color: 'warning',  // Puedes cambiar el color
                timeout: 2000   // Puedes ajustar el tiempo
              });

        fetch(`${process.env.VUE_APP_BUCKETFORMATOS}ReciboMedicover/SendMail/${this.email}/${this.ReciboId}`, {
          method: 'GET'
        })
          .then(response => {

            if (response.status === 200) {

              EventBus.$emit('show-snackbar', {
                text: `El correo fue enviado correctamente.`,
                color: 'success',  // Puedes cambiar el color
                timeout: 5000   // Puedes ajustar el tiempo
              });
            } else {
              this.$swal({
                position: 'center',
                html: `Ha ocurrido un error inesperado, <b>intenta mas tarde</b> . ${response.statusText}`,
                icon: 'error',
                confirmButtonText: 'Cerrar',
                showCloseButton: true,
                showConfirmButton: true,
                //timer: 1500,
              })
            }

            return response.status
          })

          .catch(error => {

            this.$swal({
              position: 'center',
              html: `Ha ocurrido un error inesperado, <b>intenta mas tarde</b> . ${error}`,
              icon: 'error',
              confirmButtonText: 'Cerrar',
              showCloseButton: true,
              showConfirmButton: true,
              //timer: 1500,
            })
          });
      }

      // Reiniciar el formulario y cerrar el modal
      // this.email = '';
      this.dialog = false;
    }
  }
}
</script>

<style scoped>
.headline {
  font-weight: bold;
}
</style>